import { defineComponent as _defineComponent } from 'vue'
import {computed, onMounted, getCurrentInstance} from "vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutFormGroupRegularWidth from "@/components/forms/payout/PayoutFormGroupRegularWidth.vue";
import PayoutCountriesDropdown
  from "@/components/forms/payout/forms/banks/PayoutCountriesDropdown.vue";
import EpayBankOptions from "@/components/forms/payout/forms/epay/EpayBankOptions.vue";
import PayoutMaskedInput2 from "@/components/forms/payout/forms/inputs/PayoutMaskedInput2.vue";
import EpayGenderOptions from "@/components/forms/payout/forms/epay/EpayGenderOptions.vue";
import EpayDocumentTypeOptions
  from "@/components/forms/payout/forms/epay/EpayDocumentTypeOptions.vue";
import PayoutDateInput from "@/components/forms/payout/forms/PayoutDateInput.vue";
import EpayOccupationOptions from "@/components/forms/payout/forms/epay/EpayOccupationOptions.vue";
import EpaySourceOfFundsOptions
  from "@/components/forms/payout/forms/epay/EpaySourceOfFundsOptions.vue";
import EpayBeneficiaryRelationshipOptions
  from "@/components/forms/payout/forms/epay/EpayBeneficiaryRelationshipOptions.vue";
import EpayPurposeOfRemittanceOptions
  from "@/components/forms/payout/forms/epay/EpayPurposeOfRemittanceOptions.vue";
import PayoutStatesDropdown from "@/components/forms/payout/forms/banks/PayoutStatesDropdown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EpayInputFormGroup',
  props: {
  model: {
    type: Object,
    required: true
  },
  attribute: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  required: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'text'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  datePickerOptions: {
    type: Object,
    default: () => ({})
  },
  hint: {
    type: String,
    default: ''
  },
  syncAttributes: {
    type: Array<string>,
    default: () => []
  },
  minAge: {
    type: Number,
    default: 18
  },
  countryValueKey: {
    type: String,
    default: 'alpha2'
  },
  countries: {
    type: Array,
    default: () => []
  },
  placeholder: {
    type: String,
    default: ''
  },
  stateCountry: {
    type: String,
    default: ''
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const placeholder = computed(() => {
  return props.placeholder;
})

const datePickerOptionsDefaults = computed(() => {
  // minDate and maxDate +- 100 years from current date
  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 100);
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 15);
  return {
    range: false,
    dateFormat: 'yyyy-MM-dd',
    minDate,
    maxDate,
    //view: 'years', minView: 'months',
    autoClose: true,
    language: getCurrentInstance()?.proxy?.$i18n?.locale || 'en',
  }
})


const singleDatePickerOptionsDefaults = computed(() => {
  // minDate and maxDate +- 100 years from current date
  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 100);
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - props.minAge);
  return {
    range: false,
    dateFormat: 'yyyy-MM-dd',
    minDate,
    maxDate,
    //view: 'years', minView: 'months',
    autoClose: true,
    language: getCurrentInstance()?.proxy?.$i18n?.locale || 'en',
  }
})


const datePickerOptions = computed(() => {
  return {...datePickerOptionsDefaults.value, ...props.datePickerOptions}
})

const singleDatePickerOptions = computed(() => {
  return {...singleDatePickerOptionsDefaults.value, ...props.datePickerOptions}
})


const isCountryDropdown = computed(() => {
  return attribute.value.includes('country') || type.value === 'country';
})

const isStateDropdown = computed(() => {
  return /*attribute.value.includes('state') || */type.value === 'state';
})


const type = computed(() => {
  return props.type;
})

const isMalaysiaBank = computed(() => {
  return type.value === 'bank_malaysia_spayz';
})


const isIndiaBank = computed(() => {
  return type.value === 'bank_in';
})

const isIndonesiaBank = computed(() => {
  return type.value === 'bank_id';
})


const isPhoneWithArea = computed(() => {
  return type.value === 'phonewitharea';
})


const model = computed(() => {
  return props.model;
})

const label = computed(() => {
  return props.label;
})

const required = computed(() => {
  return props.required;
})

const isGenderDropdown = computed(() => {
  return type.value == 'gender';
})

const isDatePeriod = computed(() => {
  return type.value === 'period';
})


const isDate = computed(() => {
  return type.value === 'date';
})

const attribute = computed(() => {
  // if (isPhoneWithArea.value) {
  //   console.log('props.attribute', props.attribute);
  //   const arr = props.attribute?.split(',') || ['', ''];
  //   return arr[1]
  // }
  return props.attribute;
})

const areaphoneAttributeArea = computed(() => {
  const attrs = attribute.value?.split(',') || [];
  return attrs[0] || null;
})

const areaphoneAttributePhone = computed(() => {
  const attrs = attribute.value?.split(',') || [];
  return attrs[1] || null;
})

const periodAttributeBegin = computed(() => {
  const attrs = attribute.value?.split(',') || [];
  return attrs[0] || null;
})

const periodAttributeEnd = computed(() => {
  const attrs = attribute.value?.split(',') || [];
  return attrs[1] || null;
})

const isDocumentType = computed(() => {
  return type.value === 'idtype';
})

const isOccupation = computed(() => {
  return type.value === 'occupation';
})

const isSourceOfFunds = computed(() => {
  return type.value === 'source_of_funds';
})

const isBeneficiaryRelationship = computed(() => {
  return type.value === 'beneficiary_relationship';
})

const isPurposeOfRemittance = computed(() => {
  return type.value === 'purpose_of_remittance';
})

const value = computed({
  get: () => props.model.values[attribute.value] || '',
  set: (value) => {
    const data: Record<string, any> = {};
    if (props.syncAttributes.length > 0) {
      props.syncAttributes.forEach((attr: string) => {
        data[attr] = value;
      })
    }
    props.model.values = {...props.model.values, [attribute.value]: value, ...data}
    emit('input', value);
  }
})

const hint = computed(() => {
  if (props.hint) return props.hint;
  const $i18n = getCurrentInstance()?.proxy?.$i18n;
  if (isPhoneWithArea.value) {
    return $i18n?.t('phone_hint');
  }
  return props.hint || model.value.getHint(attribute.value);
})

const hasErrors = computed(() => {
  if (isPhoneWithArea.value) {
    return model.value.errors.has(areaphoneAttributeArea.value) || model.value.errors.has(areaphoneAttributePhone.value);
  }
  return model.value.errors.has(attribute.value);
})

const errorAttribute = computed(() => {
  if (isDatePeriod.value) {
    return periodAttributeBegin.value + '|' + periodAttributeEnd.value;
  }
  if (isPhoneWithArea.value) {
    return areaphoneAttributeArea.value +
      '|' + areaphoneAttributePhone.value;
  }
  return attribute.value;
})

const disabled = computed(() => {
  return props.disabled;
})

onMounted(() => {
  model.value[attribute.value] = value.value;
})

return { __sfc: true,props, emit, placeholder, datePickerOptionsDefaults, singleDatePickerOptionsDefaults, datePickerOptions, singleDatePickerOptions, isCountryDropdown, isStateDropdown, type, isMalaysiaBank, isIndiaBank, isIndonesiaBank, isPhoneWithArea, model, label, required, isGenderDropdown, isDatePeriod, isDate, attribute, areaphoneAttributeArea, areaphoneAttributePhone, periodAttributeBegin, periodAttributeEnd, isDocumentType, isOccupation, isSourceOfFunds, isBeneficiaryRelationship, isPurposeOfRemittance, value, hint, hasErrors, errorAttribute, disabled, PayoutInputHintBlock, ErrorMessageBlock, FilteredInputWrapper, PayoutFormGroup, PayoutFormGroupRegularWidth, PayoutCountriesDropdown, EpayBankOptions, PayoutMaskedInput2, EpayGenderOptions, EpayDocumentTypeOptions, PayoutDateInput, EpayOccupationOptions, EpaySourceOfFundsOptions, EpayBeneficiaryRelationshipOptions, EpayPurposeOfRemittanceOptions, PayoutStatesDropdown }
}

})